module.exports = __webpack_public_path__ + "static/img/empty-data-icon.d2b4e9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/empty-data-icon.jpg
// module id = o+F5
// module chunks = 47